@use "src/styles/variables" as *;

.commit-modal {
  position: absolute;
  top: 155px;
  right: 10px;

  form {
    button:invalid {
      opacity: .5;
    }
  }
}



.comment-push-popover {
  --mds-popover-max-width-lg: unset !important;
  z-index: $z_index_10001;
  .comment-and-push-form {
    width: 400px;
    z-index: $z_index_10001;
  }
}

.revert-modal {
  position: absolute;
  top: 155px;
  right: 200px;

  .mds-heading {
    svg {
      width: 24px;
      height: 24px;
      margin: 2px 0 -4px 0;
    }
  }
  .revert-modal-text {
    margin-bottom: var(--size-xs);
  }
}